import { put, call, select } from 'typed-redux-saga'
import { QuestionnaireType } from '@dialogue/coredata'

import Config from 'APP/Config'
import { Recommender } from '@dialogue/services'
import CoreData from 'APP/Services/Coredata'
import WellBeingActions from 'APP/Redux/WellBeingRedux'
import { selectLoginState } from 'APP/Redux/LoginRedux'
import { selectPatientState } from 'APP/Redux/PatientRedux'
import type { RootState } from 'APP/Store/CreateStore'
import type { Recommendation } from 'APP/Store/WellBeingAssessment/types'

export const selectAccessToken = (state: RootState) => state.login.accessToken
export const selectIsWellBeingIndexAssessmentEligible = (state: RootState) => {
  return Boolean(state.patient?.profile?.eligibleServices?.wellbeing_index_assessment)
}

export function* createRecommendationsService() {
  const accessToken = yield* select(selectAccessToken)

  return new Recommender.Service(accessToken, Config.RECOMMENDER_SERVICE_URL || '')
}

export function* getLatestWellBeingAssessment() {
  try {
    const login = yield* select(selectLoginState)
    const patient = yield* select(selectPatientState)
    // @ts-expect-error FIXME: handle falsy access token
    const coredataClient = CoreData.create(login.accessToken)

    const type = QuestionnaireType.WBI
    const response = yield* call<
      Parameters<(typeof coredataClient)['getMemberQuestionnaires']>,
      (typeof coredataClient)['getMemberQuestionnaires']
    >(coredataClient.getMemberQuestionnaires, {
      // @ts-expect-error FIXME: handle falsy profile ID
      memberId: patient.profile.id,
      params: { patientId: Number(patient.profile.id), type, limit: 1 },
    })

    if (response.ok) {
      yield put(WellBeingActions.getLatestSuccess((response.data?.data || [])[0] || null))
    } else {
      throw response.originalError
    }
  } catch (_e) {
    yield put(WellBeingActions.getLatestFailure())
  }
}

export function* getRecommendations() {
  try {
    const RecommenderService = yield* call(createRecommendationsService)
    // @ts-expect-error @dialogue/recommender is source of truth, @dialogue/services is outdated
    const recommendations: Recommendation[] = yield* call(RecommenderService.getWbiRecommendations)

    yield put(WellBeingActions.getRecommendationsSuccess(recommendations))
  } catch (_e) {
    yield put(WellBeingActions.getRecommendationsFailure())
  }
}
